import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";

type FeatureCardProps = {
  title: string;
  description: string;
  href?: string;
  className?: string;
};

export function FeatureCard({ title, description, href, className }: FeatureCardProps) {
  const content = (
    <>
      <CardHeader className="pb-3">
        <h3 className="text-base font-bold tracking-tight text-foreground">{title}</h3>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground leading-relaxed">{description}</p>
        <div className="mt-4 flex justify-end">
          <div className="h-1.5 w-1.5 rounded-full bg-foreground opacity-20 transition-all duration-300 group-hover:bg-green-500 group-hover:opacity-100" />
        </div>
      </CardContent>
    </>
  );

  return (
    <Card
      className={cn(
        "group h-full rounded-none border-0 bg-card shadow-none transition-all duration-300 hover:bg-muted/15",
        className,
      )}
    >
      {href != null ? (
        <a
          href={href}
          className="block h-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
        >
          {content}
        </a>
      ) : (
        content
      )}
    </Card>
  );
}
